export const isSuiCoinAddress = (type: string) => {
  return type.toLocaleLowerCase() === '0x2::sui::sui';
};
